import axios from '@/util/requestUtil'
class Withdrawal {
  // 用户信息、交易帐号信息
  commitWithdrawal (params) {
    return axios.post('/fund/withdrawal/application/new', params)
  }

  getWithdrawalRecord (params) {
    return axios.get('/fund/withdrawal/application/records', params)
  }
  // 撤销-取款单
  cancelWithdrawal (params) {
    return axios.post('/fund/withdrawal/cancel', params)
  }
  getActiveManageFee (params) {
    return axios.get('/fund/activeManageFee/info', { params: params })
  }
}

export default new Withdrawal()
